import { css } from 'lit';

export const styles = css`
  :host {
    --column-gap: calc(15rem / var(--default-rem-px-count));
  }

  :host(:not(:last-child)) {
    padding-bottom: calc(40rem / var(--default-rem-px-count));
  }

  .barrel-wrapper {
    display: flex;
    flex-direction: column;
  }

  .hide {
    display: hidden;
  }

  .barrel-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-height: calc(60rem / var(--default-rem-px-count));
    border-top: 2px solid #222222;
  }

  .barrel-header span {
    display: flex;
    align-items: center;
  }

  .barrel-heavy-text {
    font-size: calc(16rem / var(--default-rem-px-count));
    font-weight: 500;
  }

  .barrel-header-icon {
    display: flex;
    justify-content: right;
    min-height: 2em;
    min-width: 2em;
  }

  .barrel-text {
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    line-height: 1.45em;
  }

  .product-options-wrapper {
    width: 100%;
    padding-top: calc(16rem / var(--default-rem-px-count));
    padding-bottom: calc(20rem / var(--default-rem-px-count));
  }

  .product-options-wrapper:last-child {
    border-bottom: none;
  }

  .swatch-group {
    padding-bottom: calc(14rem / var(--default-rem-px-count));
  }

  p.swatch-group-header {
    font-size: calc(14rem / var(--default-rem-px-count));
    font-style: normal;
    font-weight: 500;
    line-height: calc(14rem / var(--default-rem-px-count));
    letter-spacing: -0.18px;
    padding: calc(8rem / var(--default-rem-px-count)) 0;
  }

  .swatches {
    max-width: 100%;
    display: inline-grid;
    gap: calc(5rem / var(--default-rem-px-count));
    grid-template-columns: repeat(
      4,
      minmax(0, calc(100rem / var(--default-rem-px-count)))
    );
  }

  .needs-border {
    border: 0.5px solid var(--block-rule-color, #c0c0c0);
  }

  .material-swatches {
    max-width: 100%;
    display: inline-grid;
    gap: calc(5rem / var(--default-rem-px-count));
    grid-template-columns: repeat(
      3,
      minmax(0, calc(100rem / var(--default-rem-px-count)))
    );
  }

  .product-options-header {
    padding-bottom: calc(20rem / var(--default-rem-px-count));
  }

  .swatch-wrapper {
    display: flex;
    flex-direction: column;
    padding-bottom: calc(20rem / var(--default-rem-px-count));
    cursor: pointer;
  }

  .swatch-wrapper span {
    display: flex;
  }

  .color-swatch span {
    width: 100%;
    display: block;
    aspect-ratio: 4 / 5;
  }

  .image-swatch img {
    width: 100%;
    height: 100%;
  }

  .swatch-name {
    font-size: calc(12rem / var(--default-rem-px-count));
    letter-spacing: -0.15px;
    padding-top: 2px;
    padding-left: calc(
      var(--selected-variant-padding-width) +
        var(--selected-variant-border-width)
    );
    line-height: 1.3em;
  }

  .header-description {
    padding-bottom: calc(40rem / var(--default-rem-px-count));
  }

  .selected-swatch {
    padding: var(--selected-variant-padding-width);
    border: var(--selected-variant-border-width) solid #222222;
  }

  .selected-swatch + .swatch-name {
    font-weight: 500;
  }

  .not-selected-swatch {
    padding: calc(
      var(--selected-variant-padding-width) +
        var(--selected-variant-border-width)
    );
  }

  cta-button {
    max-width: calc(200rem / var(--default-rem-px-count));
  }

  .cta-spacer {
    height: calc(42rem / var(--default-rem-px-count));
    padding-bottom: calc(40rem / var(--default-rem-px-count));
    font-size: 15px;
  }

  @keyframes dots {
    0%,
    100% {
      content: 'Loading hardware options    ';
    }
    16% {
      content: 'Loading hardware options .  ';
    }
    33% {
      content: 'Loading hardware options .. ';
    }
    50% {
      content: 'Loading hardware options ...';
    }
    66% {
      content: 'Loading hardware options  ..';
    }
    83% {
      content: 'Loading hardware options   .';
    }
  }

  .loading::after {
    content: 'Loading hardware options    ';
    animation: dots 2s infinite steps(6);
    white-space: pre; /* Prevents collapsing of spaces */
  }

  p.loading {
    font-size: calc(16rem / var(--default-rem-px-count));
    font-weight: 500;
  }

  .no-results {
    height: calc(100rem / var(--default-rem-px-count));
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @media (min-width: 600px) {
    .swatches {
      gap: calc(10rem / var(--default-rem-px-count));
      grid-template-columns: repeat(
        4,
        minmax(0, calc(100rem / var(--default-rem-px-count)))
      );
    }

    .material-swatches {
      gap: calc(10rem / var(--default-rem-px-count));
      grid-template-columns: repeat(
        5,
        minmax(0, calc(100rem / var(--default-rem-px-count)))
      );
    }
  }
  @media (min-width: 1024px) {
    .swatches {
      grid-template-columns: repeat(
        5,
        minmax(0, calc(100rem / var(--default-rem-px-count)))
      );
    }
  }

  @media (min-width: 1200px) {
    .swatches {
      grid-template-columns: repeat(
        6,
        minmax(0, calc(100rem / var(--default-rem-px-count)))
      );
    }
  }

  @media print {
    .barrel-header {
      border-top: 1px solid #222222;
    }

    .barrel-heavy-text {
      font-size: 10px;
      letter-spacing: -0.05px;
      line-height: 18px;
    }
  }
`;
